import { createReducer } from 'reduxsauce'
import api from '../../services/api'
import { getUser } from '../../services/auth'

export const Types = {
  ADD: 'cardsDots/ADD',
  SUCCESS: 'cardsDots/SUCCESS',
  FAILURE: 'cardsDots/FAILURE'
}

const INITIAL_STATE = { cardsDots: null, errorFlash: false, loading: true }

const success = (state = INITIAL_STATE, action) => ({
  ...state,
  cardsDots: action.payload,
  loading: false
})

const add = (state = INITIAL_STATE, action) => ({
  ...state,
  // cardsDots: state.cardsDots.concat(action.payload)
  cardsDots: action.payload
})

const failure = (state = INITIAL_STATE, action) => ({
  ...state,
  errorFlash: action.payload,
  loading: false
})

export default createReducer(INITIAL_STATE, {
  [Types.ADD]: add,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure
})

export const CreatorsCardsDots = {
  fetchCardsDots: () => async dispatch => {
    try {
      const userLogged = getUser()

      const request = await api.get('CartoesPontos/ConsultarLoginId', {
        params: {
          loginId: userLogged.loginId,
          qtdRegistros: 5,
          hoje: false
        }
      })
      return dispatch({
        type: Types.SUCCESS,
        payload: request.data.resposta[0]
      })
    } catch (err) {
      return dispatch({
        type: Types.FAILURE,
        payload: true
      })
    }
  },
  addCardsDots: cardsDots => ({
    type: Types.ADD,
    payload: cardsDots
  }),
  setFlash: () => ({
    type: Types.FAILURE,
    payload: null
  })
}
